import Auth from '@shared/services/Auth';

const DEFAULT_TIMEZONE = 'Europe/Paris';

/**
 * Récupère le nom de la timezone de l'utilisateur connecté
 * @returns {string} Le nom de la timezone (ex: 'Europe/Paris', 'America/Martinique')
 */
export const getUserTimezone = () => {
  const user = Auth.user();
  return user?.user?.timezone?.name ?? DEFAULT_TIMEZONE;
};

/**
 * Récupère l'ID de la timezone de l'utilisateur connecté
 * @returns {number} L'ID de la timezone
 */
export const getUserTimezoneId = () => {
  const user = Auth.user();
  return user?.user?.timezone?.id ?? 0;
};

export default {
  getUserTimezone,
  getUserTimezoneId,
  DEFAULT_TIMEZONE,
};
